import punjab from "./Assets/Images/Punjab.jpg";
import sindh from "./Assets/Images/Sindhi.jpeg";
import kpk from "./Assets/Images/kpk.jpg";
import balochi from "./Assets/Images/balochi.jpeg";
import kashmir from "./Assets/Images/kashmiri.jpg";
import gb from "./Assets/Images/GB.jpg";

export const cuisineData = [
  {
    id: 1,
    img1: punjab,
    img2: sindh,
    img3: kpk,
    foodName1: "Punjabi Cuisine",
    foodName2: "Sindhi Cuisine",
    foodName3: "Pushton Cuisine",
  },
  {
    id: 2,
    img1: balochi,
    img2: kashmir,
    img3: gb,
    foodName1: "Balochi Cuisine",
    foodName2: "Kashmiri Cuisine",
    foodName3: "Gilgit Baltistan Cuisine",
  },
];
